/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FindAddressesResponseItems,
    FindAddressesResponseItemsFromJSON,
    FindAddressesResponseItemsFromJSONTyped,
    FindAddressesResponseItemsToJSON,
} from './';

/**
 * 
 * @export
 * @interface FindAddressesResponse
 */
export interface FindAddressesResponse {
    /**
     * 
     * @type {Array<FindAddressesResponseItems>}
     * @memberof FindAddressesResponse
     */
    items: Array<FindAddressesResponseItems>;
}

export function FindAddressesResponseFromJSON(json: any): FindAddressesResponse {
    return FindAddressesResponseFromJSONTyped(json, false);
}

export function FindAddressesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAddressesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(FindAddressesResponseItemsFromJSON)),
    };
}

export function FindAddressesResponseToJSON(value?: FindAddressesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(FindAddressesResponseItemsToJSON)),
    };
}


